import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_EVENT_TYPES = createRequestTypes('ENTITIES_EVENT_TYPES')

export const eventType = {
  request: () => action(ENTITIES_EVENT_TYPES.REQUEST),
  success: (response) => action(ENTITIES_EVENT_TYPES.SUCCESS, { response }),
  failure: (error) => action(ENTITIES_EVENT_TYPES.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/event-types/event-types-actions.js
 **/